import { render, staticRenderFns } from "./ImgPreviewComponent.vue?vue&type=template&id=05e11dac&scoped=true&"
import script from "./ImgPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./ImgPreviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImgPreviewComponent.vue?vue&type=style&index=0&id=05e11dac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e11dac",
  null
  
)

export default component.exports